import { Component, OnInit } from "@angular/core";

@Component({
  selector: "icon-share",
  templateUrl: "./share.component.html",
  styleUrls: ["./share.component.scss"],
})
export class ShareComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
